<div>
  <input id="search-token-or-string" [(ngModel)]="searchString" type="text" name="table_search" class="form-control search pull-right"
         placeholder="search">
</div>
<div class="input-group-addon">
  <i [ngClass]="searchString == '' ? 'fa fa-search hand' : 'fa fa-close hand'" (click)="searchString = ''"></i>
</div>
